import { useNavigate } from 'react-router';

import { PersonBasicInfoCard } from '~domains/profile/widgets/person-basic-info-card';

import { Screen, ScreenHeader } from '~shared/ui/screen';

import { Typography } from '@breezeventures/ui-kit/typography';

export const EmployeeProfilePage = () => {
  const navigate = useNavigate();

  return (
    <Screen header={<ScreenHeader onBack={() => navigate(-1)} />}>
      <Typography.Title size="s" tag="h2" className="py-6">
        Profile
      </Typography.Title>
      <PersonBasicInfoCard />
    </Screen>
  );
};
